import { motion } from "framer-motion";

import { content } from "../../content/content";
import { fadeIn, fadeUp } from "../../hooks/useScrollReveal";
import { lookup } from "../../lib/lookup";
import { FlourishDivider } from "../Flourish";
import { LotusMandala } from "../Ornaments";

const PILLAR_COLOR = {
  rural: "text-purple",
  community: "text-saffron-dark",
  women: "text-violet",
  livelihoods: "text-purple-light",
} satisfies Record<string, string>;

export function Mission() {
  return (
    <section className="paper-grain overflow-hidden bg-warm-white py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="relative mx-auto max-w-2xl">
          <LotusMandala className="pointer-events-none absolute top-1/2 left-1/2 z-0 h-[320px] w-[320px] -translate-x-1/2 -translate-y-1/2 text-saffron-dark/12 md:h-[420px] md:w-[420px]" />
          <motion.div
            className="relative z-10 text-center"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
          >
            <p
              data-edit-id="content.mission.eyebrow"
              className="mb-7 font-body text-xs font-medium tracking-[0.22em] text-saffron-dark uppercase"
            >
              {content.mission.eyebrow}
            </p>
            <h2
              data-edit-id="content.mission.statement"
              className="text-balance font-display text-[clamp(1.35rem,2.6vw,2.1rem)] leading-[1.45] font-light text-ink-light"
            >
              {content.mission.statement}
            </h2>
          </motion.div>
        </div>

        <motion.div
          className="mt-16"
          variants={fadeIn}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <FlourishDivider />
        </motion.div>

        <motion.div
          className="mx-auto mt-16 grid max-w-4xl gap-8 md:grid-cols-4"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {content.mission.pillars.map((pillar) => (
            <div
              key={pillar.id}
              data-edit-id={`content.mission.pillars[${pillar.id}]`}
              className="text-center"
            >
              <p
                data-edit-id={`content.mission.pillars[${pillar.id}].label`}
                className={`font-display text-sm font-medium tracking-wide ${lookup(PILLAR_COLOR, pillar.id) ?? "text-ink"}`}
              >
                {pillar.label}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
